import React from 'react';
import { getDefaultPagingNumberOfItems } from '../../../helpers/PackageJsonHelper';
import { newSearchCustomers, searchCustomersSalesforce } from '../../../networking/Networking';
import { getStyle } from '../../../styles/styles';
import NewEditableGrid from '../../shared/NewEditableGrid';
import { searchCustomerByIdNameMin } from '../../../networking/NetworkingCustomers';

export default class NettingCustomerSearch extends React.Component {
    state = {
        searchTerm: '',
        pages: 1,
        totalPages: 0,
        customerList: [],
        newSearch: false,
        filter: false,
        columnDetail: null,
        criteria: {
            orderNroFrom: '',
            CustomerIDName: '',
            valueDateFrom: '',
            valueDateTo: '',
            status: '',
            lockedside: '',
            CustomerID: '',
            customerList: [],
            statusList: [],
            lockedsideList: [],
            objCustomer:{}
        }
    }

    componentDidMount() {
        this.loadCustomerSalesforce();   
    }

    loadCustomerSalesforce = async () => {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);        
        let sfaccount = urlParams.get('sfaccount');
        if(sfaccount!==undefined && sfaccount!=='' && sfaccount!==null){
            const value = await searchCustomersSalesforce(sfaccount);
            if (value !== undefined) {                
                this.props.onCustomerSelected(value, 2);
            }            
        } 
    }

    handleUpdateSearchTerm = (event) => {
        let searchTerm = event.target.value;
        this.setState({ searchTerm: searchTerm });
        if(searchTerm!=''){
            this.handleSearchClick();
        }        
    }

    loadCustomers = async () => {
        const itemsPerPage = getDefaultPagingNumberOfItems();
        const value = await newSearchCustomers(this.state.searchTerm, 0, 0);
        if (value.customers !== undefined) {
            const totalCount = value.totalCount;
            const totalPages = Math.ceil(totalCount / itemsPerPage);
            let _columnDetail = null;
            if (value.columnDetail != null) {
                _columnDetail = JSON.parse(value.columnDetail);
            }
            this.setState({
                totalPages,
                newSearch: true,
                filter: true,
                customerList: value.customers,
                columnDetail: _columnDetail
            });
        }
    }

    changePage = (value) => {
        this.setState({ pages: value });
    }

    handleSearchClick = async (event) => {
        if (event != null) {
            event.preventDefault();
        }
        await this.loadCustomers();
    }

    handleRecordClick = (objCustomer) => {
        this.props.onCustomerSelected(objCustomer, 2);
    }

    getAllCustomers = async () => {
        const value = await newSearchCustomers('', 0, 0);
        if (value.customers !== undefined) {
            return value.customers;
        } else {
            return [];
        }
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchClick();
        }
    };
    
    searchCustomer(query) {
        console.group("searchCustomer");
        console.log(query);
        console.groupEnd();
        searchCustomerByIdNameMin(query).then(
            (response) => {
                if (response.customers !== undefined) {
                    for (var i = 0; i < response.customers.length; i++) {
                        response.customers[i].value = response.customers[i].CustomerID;
                        response.customers[i].name = response.customers[i].CustomerIDName;
                    }
                    this.setState({ criteria: { ...this.state.criteria, customerList: response.customers} });
                }
            }
        )
    }
    
    handleUpdateCustomerIDName(value) {
        if (value.value !== undefined) {
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: value.name !== 'select' ? value.name : '', CustomerID: value.value !== 'select' ? value.value : '', objCustomer: value } });
        }else if (value.value === undefined){
            this.setState({ criteria: { ...this.state.criteria, CustomerIDName: '', CustomerID: '', objCustomer:{} } });
        }
    }

    render() {
        return (
            <div>
                <form className="uk-grid">
                    <div className="uk-width-1-2">
                        <div className="uk-margin" style={{ ...getStyle().inputStyle, marginTop: '5px' }}>
                            <input
                                className="uk-input"
                                id="searchTerm"
                                type="text"
                                value={this.state.searchTerm}
                                onChange={this.handleUpdateSearchTerm}
                                onKeyPress={this.handleKeyPress}
                                autoFocus={true} />
                        </div>
                    </div>
                    <div className="uk-width-1-2">
                        <div className="uk-margin" style={getStyle().inputStyle}>
                            <button className="uk-button uk-button-green" onClick={this.handleSearchClick}>Search</button>
                        </div>
                    </div>
                </form>
                
                <NewEditableGrid
                    data={this.state.customerList}
                    columnDetails={this.state.columnDetail}
                    enableClick={true}
                    clickFunction={this.handleRecordClick}
                    newSearch={this.state.newSearch}
                    useDeleteButton={false}
                    hiddenHeaders={['FeeStructureID', 'WireFeeSide', 'RelatedWireFeeID', 'DefaultBuyCurrencyID', 'DefaultSellCurrencyID']}
                    usePaginator={true}
                    changePage={this.changePage}
                    numberOfPages={this.state.totalPages}
                    pageNumber={this.state.pages}
                    numberPerPage={getDefaultPagingNumberOfItems()}
                    enableSortByHeader={true}
                    useFilter={this.state.filter}
                    filterFunction={this.getAllCustomers}
                />
            </div>
        )
    }
}